import redirects from "./surface-redirects.json";

export function surfaceRedirectResponse(request: Request): Response | undefined {
  if (request.method !== "GET" && request.method !== "HEAD") return undefined;
  const url = new URL(request.url);
  const path = url.pathname.replace(/\/$/, "");
  if (!Object.hasOwn(redirects, path)) return undefined;
  return new Response(null, {
    status: 301,
    headers: { Location: redirects[path as keyof typeof redirects] + url.search },
  });
}

export function surfaceHref(path: string): string {
  const url = new URL(path, "https://bavimail.com");
  if (url.origin !== "https://bavimail.com") return path;
  const key = url.pathname.replace(/\/$/, "");
  return Object.hasOwn(redirects, key)
    ? redirects[key as keyof typeof redirects] + url.search + url.hash
    : path;
}
